export enum DOMAINS_MANAGEMENT {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=325511780
     */
    CERTIFICATE_DEPLOYED = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=325511785
     */
    CERTIFICATE_DEPLOYING = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=325037929
     */
    CERTIFICATE_DEPLOYMENT_TITLE = 'DOMAINS_MANAGEMENT.CERTIFICATE_DEPLOYMENT_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327361274
     */
    CERTIFICATE_GENERATION_TITLE = 'DOMAINS_MANAGEMENT.CERTIFICATE_GENERATION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=325511776
     */
    CUSTOM_CERTIFICATE_DEPLOYING = 'DOMAINS_MANAGEMENT.CUSTOM_CERTIFICATE_DEPLOYING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327439015
     */
    DOMAIN_CONFIGURATION_TITLE = 'DOMAINS_MANAGEMENT.DOMAIN_CONFIGURATION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=674524761
     */
    DOMAIN_MIGRATED_SUCCESS = 'DOMAINS_MANAGEMENT.DOMAIN_MIGRATED_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=674525034
     */
    DOMAIN_MIGRATED_READY = 'DOMAINS_MANAGEMENT.DOMAIN_MIGRATED_READY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=326481333
     */
    NO_VANITY_URL = 'DOMAINS_MANAGEMENT.NO_VANITY_URL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327439033
     */
    PENDING_FIRST_STEP = 'DOMAINS_MANAGEMENT.PENDING_FIRST_STEP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=444611739
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_BLOCKED = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_BLOCKED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=444611812
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_NO_MS = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_NO_MS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=444611822
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_JIT = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_JIT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=444611786
     */
    PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_V1 = 'DOMAINS_MANAGEMENT.PLATFORM_DEPLOYMENT_ERROR_MESSAGE_SAML_V1',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=641475420
     */
    PLATFORM_URLS = 'DOMAINS_MANAGEMENT.PLATFORM_URLS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327273940
     */
    RECORD_INFO = 'DOMAINS_MANAGEMENT.RECORD_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327119270
     */
    RECORD_NAME = 'DOMAINS_MANAGEMENT.RECORD_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327119249
     */
    RECORD_TYPE = 'DOMAINS_MANAGEMENT.RECORD_TYPE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327185782
     */
    RECORD_VALIDITY_DATE = 'DOMAINS_MANAGEMENT.RECORD_VALIDITY_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327193286
     */
    RECORD_VALIDITY_DATE_INFO = 'DOMAINS_MANAGEMENT.RECORD_VALIDITY_DATE_INFO',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327119297
     */
    RECORD_VALUE = 'DOMAINS_MANAGEMENT.RECORD_VALUE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=359722820
     */
    ROOT_APEX_DOMAIN = 'DOMAINS_MANAGEMENT.ROOT_APEX_DOMAIN',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=320908098
     */
    SUBTITLE = 'DOMAINS_MANAGEMENT.SUBTITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=319944527
     */
    SUPPORT_MAIL = 'DOMAINS_MANAGEMENT.SUPPORT_MAIL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=326657891
     */
    SUPPORT_QUESTIONS = 'DOMAINS_MANAGEMENT.SUPPORT_QUESTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=449296013
     * TODO: Split into two components
     */
    SUPPORT_QUESTIONS_V2 = 'DOMAINS_MANAGEMENT.SUPPORT_QUESTIONS_V2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=319927908
     */
    THE_HIVE = 'DOMAINS_MANAGEMENT.THE_HIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=318880072
     */
    TITLE = 'DOMAINS_MANAGEMENT.TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=319927592
     */
    UPDATE_DOMAIN_CERTIFICATES = 'DOMAINS_MANAGEMENT.UPDATE_DOMAIN_CERTIFICATES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=449287867
     */
    UPDATE_DOMAIN_CERTIFICATES_V2 = 'DOMAINS_MANAGEMENT.UPDATE_DOMAIN_CERTIFICATES_V2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=326481740
     */
    VANITY_URL_CUSTOM = 'DOMAINS_MANAGEMENT.VANITY_URL_CUSTOM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=327368939
     */
    WAITING_LUMAPPS_INFO = 'DOMAINS_MANAGEMENT.WAITING_LUMAPPS_INFO',
}
